module.exports = __webpack_public_path__ + "img/brand-webpack.b7bef091.svg";